import { render, staticRenderFns } from "./ivr-type-column.vue?vue&type=template&id=816ce824"
import script from "./ivr-type-column.vue?vue&type=script&lang=js"
export * from "./ivr-type-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports